import * as React from 'react';

import type { FaqModuleItem } from '@coursera-web/cds-labs';
import { FAQsModule } from '@coursera-web/cds-labs';
import type { CmlContent } from '__generated__/graphql-types-do-not-use';

import { CML, toPlainText } from 'bundles/cml';
import FaqsSchemaMarkup from 'bundles/seo/components/FaqsSchemaMarkup';
import HelpCenterInfo from 'bundles/unified-common/components/HelpCenterInfo';
import type { ConsumerCoursePageFieldsFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/ConsumerCoursePageQuery';
import convertToCmlContent from 'bundles/unified-description-page-common/utils/convertToCmlContent';
import getProjectPageFaqs from 'bundles/unified-description-page-common/utils/getProjectPageFaqs';

type Props = {
  pageData: ConsumerCoursePageFieldsFragment;
};

const ProjectFAQsModuleRenderer = ({ pageData }: Props) => {
  if (!pageData.courseType) {
    return null;
  }

  const faqs = getProjectPageFaqs(pageData.courseType, !!pageData.hasFullDiscount);

  const convertedFaqs: FaqModuleItem[] = [];
  const textFaqs: { question: string; answer: string }[] = [];
  faqs.forEach((faq) => {
    const question = toPlainText(convertToCmlContent(faq.question as CmlContent)) || '';

    convertedFaqs.push({
      question,
      answer: <CML cml={faq.answer as CmlContent} />,
    });

    textFaqs.push({
      question,
      answer: toPlainText(convertToCmlContent(faq.answer as CmlContent)) || '',
    });
  });

  return (
    <>
      <FAQsModule faqs={convertedFaqs} moreInfo={<HelpCenterInfo />} />
      <FaqsSchemaMarkup faqs={textFaqs} />
    </>
  );
};

export default ProjectFAQsModuleRenderer;
